import { Button } from "@payping/web-components";

import useTranslator from "@/shared/translate/translator";
import type { TransactionReportViewModel } from "@/shared/domain/transactions";
import { RefundInfo } from "@/refund/repository/refund/v1/refund-v1-api";

type Props = {
  details?: TransactionReportViewModel;
  refundInfo?: RefundInfo;
};

const RetryRefundAction: React.FC<Props> = () => {
  const { t } = useTranslator("refund.action");

  const isRefundRetriable = false;

  const retryRefund = () => {};

  return (
    <>
      {isRefundRetriable && (
        <Button type="primary" onClick={retryRefund}>
          {t("retry")}
        </Button>
      )}
    </>
  );
};
export default RetryRefundAction;
